import { render, staticRenderFns } from "./dutyNotice.vue?vue&type=template&id=025127c1&scoped=true&"
import script from "./dutyNotice.vue?vue&type=script&lang=js&"
export * from "./dutyNotice.vue?vue&type=script&lang=js&"
import style0 from "./dutyNotice.vue?vue&type=style&index=0&id=025127c1&lang=scss&scoped=true&"
import style1 from "./dutyNotice.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "025127c1",
  null
  
)

export default component.exports